import { lockScroll } from '~/utils/scroll';

const unlockScroll = () => {
  lockScroll(false);
};

export default unlockScroll;
